export const NAME = 'home';

const SET_UI_NODE = `SET_UI_NODE_${NAME}`;

export const setUINode = (payload) => {
	return {
		type: SET_UI_NODE,
		payload,
	};
};

const ACTION_MAP = {
	[SET_UI_NODE]: (state, action) => {
		return {
			...state,
			node: action.payload,
		};
	},
};

const initialState = {
	node: null,
};

export const reducer = (state = initialState, action) => {
	const actionFunc = ACTION_MAP[action.type];

	return actionFunc ? actionFunc(state, action) : state;
};
